// Unified sidebar/menu definition, shared by DesktopApp.jsx and
// MobileApp.jsx. One merged list (not two separate role-specific lists)
// so the two shared entries -- Association Laws and Settings -- are
// defined once and everything stays in a single, stable order.
//
// The menu always shows every item, board and resident alike (rather
// than hiding items the current role can't use); which items are
// clickable depends on the active role. Board is a superset of
// Resident, so with role "board" every item is enabled; with role
// "resident" only the items whose `roles` include "resident" are.

import {
  LayoutDashboard, MessageSquare, Ticket, FileCheck, BookOpen, Settings as SettingsIcon,
} from "lucide-react";

export const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["resident"] },
  { id: "counsel", label: "Counsel", icon: MessageSquare, roles: ["board"] },
  { id: "request", label: "Request", icon: Ticket, roles: ["resident"] },
  { id: "residentiq", label: "ResidentIQ", icon: MessageSquare, roles: ["resident"] },
  { id: "resolutions", label: "Resolutions", icon: FileCheck, roles: ["board"] },
  { id: "assoclaws", label: "Association Laws", icon: BookOpen, roles: ["board", "resident"] },
  { id: "settings", label: "Settings", icon: SettingsIcon, roles: ["board", "resident"] },
].map((item, i) => ({ ...item, num: String(i + 1).padStart(2, "0") }));

/** The full menu, annotated with whether each item is usable under the
 * active role. Board is a superset -- every item comes back enabled.
 * Resident only enables the items whose `roles` include "resident". */
export function navItemsWithAccess(role) {
  return NAV_ITEMS.map((item) => ({
    ...item,
    enabled: role === "board" || item.roles.includes(role),
  }));
}

/** {tabId: IconComponent} -- the full set, independent of role, since
 * the menu no longer hides items by role. */
export function navIcons() {
  return Object.fromEntries(NAV_ITEMS.map((item) => [item.id, item.icon]));
}
